import getCrew from "./getCrew";
import createCrew from "./createCrew";
import updateCrew from "./updateCrew";
import deleteCrew from "./deleteCrew";
import getCrews from "./getCrews";

export { getCrew, createCrew, updateCrew, deleteCrew, getCrews };

export default { getCrew, createCrew, updateCrew, deleteCrew, getCrews };
